module.exports = __webpack_public_path__ + "img/xinsx.7f3ca152.svg";